import { ROLE_NURSE } from './constants'

const isNurse = userRoles => {
  return userRoles.length === 1 && userRoles[0] === ROLE_NURSE
}

export { isNurse }
